import { Injectable } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { HttpClient } from '@angular/common/http';
import { Profile, Password, VMuser, ZoomMeeting, StripePyout, Panelconfig } from './model/model.class';
import 'rxjs/add/operator/map';
import { BehaviorSubject, Observable } from 'rxjs';
import { Smtp } from '../setting/model/model.class';

@Injectable()
export class ProfileService extends AppService<Profile>{


  getSmsTemplate(filter:any):Observable<any>
  {    
    let tmp=this.appmod;   
    this.appmod="custom/getSmsTemplate";
    let data=super.getService(filter);
    this.appmod=tmp;
    return data;
  }
  getBrandIdService(type:any):Observable<any>
  {    
    let tmp=this.appmod;   
    this.appmod="callerid";
    let data=super.getService(type);
    this.appmod=tmp;
    return data;
  }
  campRegistration(cdata){
    let tmp = this.appmod;
    this.appmod ="custom/RegisCamp";
    let data = super.saveService(cdata)
    this.appmod=tmp;
    return data;
  }
  regiscamp(fdata: any): Observable<any> {
    console.log(fdata);
    let tmp = this.appmod;
    this.appmod = "custom/camp_regis"; 
    let data = super.saveService(fdata);
    this.appmod = tmp;
    return data;
  }
    //  // corporate account campaign reg
    //  regiscamp(fdata: any): Observable<any> {
    //   console.log(fdata);
    //   let tmp = this.appmod;
    //   this.appmod = "custom/camp_regis"; 
    //   let data = super.saveService(fdata);
    //   this.appmod = tmp;
    //   return data;
    // }

  constructor(protected http:HttpClient) {
    super(http);   
    this.appmod="profile";
  }  
  
  public DeleteAccount():Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/deleteaccount";   
    let delacc = this.getService();
    this.appmod=tmp;
    return delacc; 
  }  
  public unvrfBrnd():Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/unveryBrand";
    let unverify=this.getService();
    this.appmod=tmp ;
    return unverify;
  }

  public GetRolesPermission(filter:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="supervisorlist";   
    let delacc = this.getService("rolespermission", filter);
    this.appmod=tmp;
    return delacc; 
  } 

  public brandSmsOtp(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/brandSmsOtp";   
    let delacc = this.saveService(sdata);
    this.appmod=tmp;
    return delacc; 
  }
  
}

@Injectable()
export class PasswordService extends AppService<Password>{
  
  constructor(protected http:HttpClient) {
    super(http);    
    this.appmod="profile";
  } 

  public matchOldPass():Observable<any>
  {
   
    let tmp = this.appmod;
    this.appmod="custom/matcholdpass";   
    let delacc = this.getService();
    this.appmod=tmp;
    return delacc; 
  }
  
 
}


@Injectable()
export class VMuserService extends AppService<VMuser>{
  
  constructor(protected http:HttpClient) {
    super(http);    
    this.appmod="vmuserverify";
  }
  
  public VerifyAccount(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/vmuserverify";   
    let delacc = this.saveService(sdata);
    this.appmod=tmp;
    return delacc; 
  }
  
  public AccountSetting(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/vmsavesetting";   
    let delacc = this.saveService(sdata);
    this.appmod=tmp;
    return delacc; 
  }

  public SyncCallerIDCredit(vmid:string):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/getcalleridcredit";   
    let delacc = this.getService(vmid);
    this.appmod=tmp;
    return delacc; 
  }

  public Syncminutes(vmid:string):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/getvmminutes";   
    let delacc = this.getService(vmid);
    this.appmod=tmp;
    return delacc; 
  }
 
}

@Injectable()
export class ZoomService extends AppService<ZoomMeeting>{
  
  constructor(protected http:HttpClient) {
    super(http);    
    this.appmod="zoommeeting";
  }

  public SaveZoomURL(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/savezoomurl";   
    let zoomurl = this.saveService(sdata);
    this.appmod=tmp;
    return zoomurl; 
  }
} 

@Injectable()
export class SPSmtpService extends AppService<Smtp>{

  private __data1 = new BehaviorSubject<any>("green");
  public themecolor1= this.__data1.asObservable();
   
  private __data = new BehaviorSubject<any>("green");
  public themecolor= this.__data.asObservable();

  public SetData(V:any){
    this.__data.next(V)
  }

  public SetData1(V:any){
    this.__data1.next(V)
  }
  // private __sdata = new BehaviorSubject<any>("green");
  // public sthemecolor= this.__sdata.asObservable();

  // public SETData(V:any){
  //   this.__sdata.next(V)
  // }

  constructor(public http:HttpClient) {
    super(http);
    this.appmod="smtp";
  }

  public SendTestEmail(sdata:any):Observable<any>
  {
    console.log("sdata",sdata);
    let tmp = this.appmod;
    this.appmod="custom/sendtestemail";   
    let delacc = this.saveService(sdata);
    this.appmod=tmp;
    return delacc; 
  }
  public getCampList():Observable<any>
  {
    let temp = this.appmod;
    this.appmod="custom/campaignList";
    let delacc = this.getService();
    this.appmod=temp;
    return delacc;
  }
  public savedata(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/saveservice";   
    let delacc = this.saveService(sdata);
    this.appmod=tmp;
    return delacc; 
  }

  public ResetSMTP(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/resetsmtp";   
    let delacc = this.saveService(sdata);
    this.appmod=tmp;
    return delacc; 
  }

  public MakeDefaultSMTP(sdata:any, key:number):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/makedefaultsmtp";   
    let delacc = this.updateService(sdata, key);
    this.appmod=tmp;
    return delacc; 
  }

  
  public request_SMTP(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/request_SMTP";   
    let delacc = this.saveService(sdata);
    this.appmod=tmp;
    return delacc; 
  }
  public get_Permission(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/get_Permission";   
    let delacc = this.getService(sdata);
    this.appmod=tmp;
    return delacc; 
  }
  
}

@Injectable()
export class StripePayoutsService extends AppService<StripePyout>{
  
  constructor(public http:HttpClient) {
    super(http);
    this.appmod="stripepayouts";
  }

  public CreatePauoutAccount(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/createpayoutaccount";   
    let pdata = this.saveService(sdata);
    this.appmod=tmp;
    return pdata; 
  }

  public UpdatePauoutAccount(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/updatepayoutaccount";   
    let pdata = this.saveService(sdata);
    this.appmod=tmp;
    return pdata; 
  }
  
  public DeletePauoutAccount(key:number):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/deletepayoutaccount";   
    let pdata = this.saveService(key);
    this.appmod=tmp;
    return pdata; 
  }
}

@Injectable()
export class PanelconfigService extends AppService<Panelconfig>{
  
  constructor(protected http:HttpClient) {
    super(http);    
    this.appmod="panelconfig";
  } 
 
  public savepanel(sdata:any):Observable<any>
  {
    let tmp = this.appmod;
    this.appmod="custom/panelsave";   
    let delacc = this.saveService(sdata);
    this.appmod=tmp;
    return delacc; 
  }


  
}